import { safe } from '../lib/safe';
import type { Workspace } from '../types';

const KEY = 'kuer.workspace.v1';

/**
 * Local storage is a convenience, not the system of record — private browsing
 * and locked-down environments make it throw. Every call is guarded (`safe()`,
 * `src/lib/safe.ts`) so the app keeps working; the workspace file export is the
 * reliable way to keep data.
 */
export function storageAvailable(): boolean {
  return safe(() => {
    const probe = '__kuer_probe__';
    localStorage.setItem(probe, '1');
    localStorage.removeItem(probe);
    return true;
  }, false);
}

export function readWorkspace(): unknown | null {
  const raw = safe(() => localStorage.getItem(KEY), null);
  if (raw === null) return null;
  return safe<unknown | null>(() => JSON.parse(raw), null);
}

export function writeWorkspace(workspace: Workspace): void {
  safe(() => localStorage.setItem(KEY, JSON.stringify(workspace)), undefined);
}

export function clearWorkspace(): void {
  safe(() => localStorage.removeItem(KEY), undefined);
}
